import React, {useState} from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import {Typography, Box} from '@mui/material';
import clsx from 'clsx';
import styles from '../../../components/ChartWrapper/ChartWrapper.module.scss';
import {FullScreenButton} from '@ui/ChartWrapper/components/FullScreenButton';

export const ChatMessageMarkdown = ({text}: {text: string}) => {
    // если text начинается с '|' — обязательно добавляем две пустые строки перед ним
    const normalized = text.trimStart().startsWith('|') ? '\n\n' + text.trim() : text;

    // теперь убираем отступы у каждой строки
    const dedented = normalized
        .split('\n')
        .map((l) => l.trimStart())
        .join('\n');

    const [isFullScreen, setIsFullScreen] = useState(false);

    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
                // обычный текст
                p: ({children}) => (
                    <Typography
                        variant='body2'
                        sx={{
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                            whiteSpace: 'pre-wrap',
                            backgroundColor: 'transparent !important',
                        }}
                    >
                        {children}
                    </Typography>
                ),

                // таблица
                table: ({children}) => (
                    <Box
                        className={clsx({
                            [styles.fullscreen]: isFullScreen,
                        })}
                        sx={{
                            overflowX: 'auto',
                            width: '100%',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                                mb: 1,
                            }}
                        >
                            <FullScreenButton
                                isFullScreen={isFullScreen}
                                setIsFullScreen={setIsFullScreen}
                            />
                        </Box>

                        <Box
                            component='table'
                            sx={{
                                minWidth: '300px',
                                display: 'inline-block',
                                maxWidth: isFullScreen ? '100%' : '300px', //todo: хардкод ширина т.к. таблица тянет весь блок чата по ширине
                                borderCollapse: 'collapse',
                                overflowX: 'auto',
                                width: 'auto',
                            }}
                        >
                            {children}
                        </Box>
                    </Box>
                ),

                th: ({children}) => (
                    <Box
                        component='th'
                        sx={{
                            border: '1px solid var(--mui-palette-divider)',
                            p: 1,
                            background: 'rgba(0,0,0,0.04)',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {children}
                    </Box>
                ),
                td: ({children}) => (
                    <Box
                        component='td'
                        sx={{
                            border: '1px solid var(--mui-palette-divider)',
                            p: 1,
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {children}
                    </Box>
                ),
            }}
        >
            {dedented}
        </ReactMarkdown>
    );
};
